<template>
  <div v-if="redpacketConfig && redpacketConfig.length" ref="container" class="plv-ia-app plv-ia-rpr">
    <template v-if="currentStep === step.preRedpacket">
      <pre-redpacket
        v-if="core"
        :lang="lang"
        :core="core"
        @change-current-step="changeCurrentStep"
        @open-pre-redpacket-detail="openPreRedpacketDetail"
        @send-pre-redpacket="sendPreRedpacket"/>
    </template>
    <template v-else-if="currentStep === step.preRedpacketDetail">
      <pre-redpacket-detail
        :lang="lang"
        :pre-redpacket-detail="preRedpacketDetail"
        @change-current-step="changeCurrentStep"
        @send-pre-redpacket="sendPreRedpacket" />
    </template>
    <template v-else-if="currentStep === step.createRedpacket">
      <div v-show="!showPay">
        <send
          ref="send"
          :redpack-preset-enabled="redpackPresetEnabled"
          :redpack-cash-enabled="redpackCashEnabled"
          :delay-disable="delayDisable"
          :core="core"
          :lang="lang"
          :online-user-number="onlineUserNumber"
          :redpacket-config="redpacketConfig"
          :random-max-total-amount="randomMaxTotalAmount"
          :random-max-count="randomMaxCount"
          :equal-single-max-amount="equalSingleMaxAmount"
          :equal-single-max-count="equalSingleMaxCount"
          :equal-max-total-amount="equalMaxTotalAmount"
          :scoreRedPackEnabled="scoreRedPackEnabled"
          :red-pack-currency-type="redPackCurrencyType"
          :point-unit="pointUnit"
          @on-send="handleSendRp"
          @change-current-step="changeCurrentStep"
        />
      </div>
      <qrcode
        v-if="showPay"
        :qrcode-url="payImg"
        :status="payStatus"
        :lang="lang"
        @on-close="handleClosePay"
      />
    </template>
    <template v-else-if="currentStep === step.sendRedpacketSuccess">
      <SendSuccess :lang="lang"  @change-current-step="changeCurrentStep" />
    </template>
  </div>
</template>

<script>
import Send from './components/send';
import Qrcode from './components/qrcode';
import commonMixin from '../app-mixin';
import Locale from '@/mixins/locale';
import inputLimit from './mixins/inputLimit';
import PreRedpacket from './components/pre-redpacket';
import PreRedpacketDetail from './components/pre-redpacket-detail';
import SendSuccess from './components/send-success';
import { step } from './config';

export default {
  name: 'ILSRedpacket',
  components: {
    PreRedpacket,
    Send,
    Qrcode,
    PreRedpacketDetail,
    SendSuccess
  },
  mixins: [commonMixin, Locale, inputLimit],
  props: {
    /** 红包雨SDK 实例 */
    core: {
      type: Object,
      default: null
    },
    /** 红包开关配置 */
    redpacketConfig: {
      type: Array,
      default: (array) => {
        const redpackType = ['rain', 'normal', 'password'];
        const arr = [];
        for (const arrKey in array) {
          if (redpackType.includes(array[arrKey])) {
            arr.push(array[arrKey]);
          }
        }
        return arr;
      }
    },
    scoreRedPackEnabled: {
      type: String,
      default: 'N'
    },
    pointUnit: String,
    redpackPresetEnabled: {
      type: Boolean,
      default: false
    },
    // 红包tab 超管开关
    redPackCurrencyType: {
      type: String,
      // cash：现金 score：积分 cashAndScore：现金+积分
      default: 'cash'
    },

    // 微信公众号支付开关
    redpackCashEnabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      onlineUserNumber: 0, // 在线人数
      payImg: '',
      showPay: false,
      payStatus: '',
      delayDisable: false, // 默认可以发起定时红包，如果有定时红包存在则不能发起
      step,
      currentStep: step.createRedpacket,
      preRedpacketDetail: {}, // 预设红包详情
    };
  },
  destroyed() {
    this.stopPollPayStatus();
  },
  mounted() {
    this.getNewest();
    this.onlineUserNumber = this.core.onlineUserNumber;
    this.core.on('onlineUserNumberChange', this.handleOnlineUserNumberChange);
  },
  methods: {
    // 发送预设红包
    async sendPreRedpacket(item) {
      try {
        await this.core.sendPreRedpacket(item.id);
        this.changeCurrentStep(step.sendRedpacketSuccess);
      } catch (error) {
        this.$iaMessage.default(error.toString());
      }
    },
    changeCurrentStep(step) {
      this.currentStep = step;
      this.$emit('change-dialog-title', this.t(`plvIA.redpacket.${step}Title`));
    },
    openPreRedpacketDetail(item) {
      this.changeCurrentStep(step.preRedpacketDetail);
      this.preRedpacketDetail = item;
    },
    handleOnlineUserNumberChange({ onlineUserNumber }) {
      this.onlineUserNumber = onlineUserNumber;
    },
    // 获取定时红包的状态
    async getNewest() {
      try {
        const data = await this.core.getNewest();
        if (
          data &&
          data.timeEnabled === 'Y' &&
          data.sendTime > data.serverTime
        ) {
          this.delayDisable = true;
        }
      } catch (e) {
      }
    },
    async handleSendRp(params, payType) {
      try {
        const data = await this.core.sendRP(params);
        if (payType === 'cash') {
          this.showPay = true;
          this.payImg = data.wxPayNativeOrderResult.codeUrl;
          this.pollPayStatus(data.redPackId);
        } else {
          this.$refs.send?.getScoreLimit();
          this.$iaMessage.default(this.t('plvIA.redpacketRain.sendSuccess'));
          this.$emit('close');
        }
      } catch (error) {
        const message = error.message;
        this.$iaMessage.default(message || this.t('plvIA.redpacketRain.taost3'));
        throw error;
      }
    },
    handleClosePay() {
      this.stopPollPayStatus();
      this.showPay = false;
    },
    pollPayStatus(logId) {
      this.statusTimer = setInterval(() => {
        this.getPayStatus(logId);
      }, 1500);
      this.getPayStatus(logId);
    },
    stopPollPayStatus() {
      if (this.statusTimer) {
        clearInterval(this.statusTimer);
        this.statusTimer = null;
      }
    },
    async getPayStatus(logId) {
      try {
        const data = await this.core.getPayStatus(logId);
        this.payStatus = data.status;
        if (data.status === 'WAIT_PAY') return;
        this.stopPollPayStatus();
        // 更新定时红包状态
        this.getNewest();
        // 关闭
        setTimeout(() => {
          this.showPay = false;
          this.payStatus = '';
          this.$emit('close');
        }, 1500);
      } catch (error) {
        this.$iaMessage.default('获取支付状态失败，请重试');
        throw error;
      }
    }
  }
};
</script>

<style lang="scss">
.plv-ia-rpr {
  position: relative;
  // padding: 0 24px 24px;
  padding: 0 24px 24px !important;
  overflow-x: hidden;
  overflow-y: auto;
  height: 480px;
  * {
    box-sizing: border-box;
  }
}
.plv-ia-rpr-tab {
  border-bottom: 1px solid #eceff1;
  &__item {
    display: inline-block;
    width: 88px;
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    color: #546e7a;
    text-align: center;
    position: relative;
    cursor: pointer;
    &.selected {
      color: #2196f3;
      &:after {
        content: '';
        position: absolute;
        background: #2196f3;
        width: 88px;
        height: 2px;
        bottom: 0;
        left: 0;
      }
    }
  }
}
</style>
